import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isProd = environment.production;
  isStaging = environment.isStaging;

  emailAddress?: string;
  password?: string;
  subscription?: Subscription;
  loggingIn: boolean = false;
  errorMessage?: string;


  constructor( 
    public authService: AuthService,
    public route: ActivatedRoute, 
    public router: Router, 
    private toastService: ToastService) {

    this.subscription = authService.isLogin.subscribe(loggedIn => {

      if (!loggedIn) {
        this.loggingIn = false;
      } else if (loggedIn) {

        this.loggingIn = true;
        if(this.router.url == '/login') {
          this.router.navigateByUrl('/');
        }
      }
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe;
    }
  }

  login() {

    this.loggingIn = true;
    this.errorMessage = "";

    this.authService.login2({ emailAddress: this.emailAddress, password: this.password }).subscribe( result => {

      this.loggingIn = true;
      this.router.navigateByUrl('/');
    }, error => {
      this.errorMessage = "Login Failed";
      this.loggingIn = false;
      //this.toastService.error(this.errorMessage);
    });
  }

}
